import styled from "styled-components";

export const Tooltip = styled.div<{ showOnLeft?: boolean }>`
  padding: 10px 8px;
  background-color: var(--menu-snow-background-color, var(--snow));
  box-shadow: var(--box-shadow)
    var(--menu-ebony-shadow-box-shadow-color, var(--ebony-shadow));
  border-radius: 2px;
  pointer-events: none;
  position: absolute;
  font-size: 13px;
  font-weight: 400;
  box-shadow: 0 6px 24px 0 rgba(152, 160, 171, 0.4);
  transform: ${props =>
    props.showOnLeft ? "translateX(-100%)" : "translateX(-50%)"};
  margin-top: 8px;
  white-space: nowrap;
  z-index: 1000;
  transition: transform 0.1s ease-in-out;
  will-change: transform;
`;

export const LogCounter = styled.div`
  margin-top: 0.5rem;
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const TooltipTitle = styled.div`
  color: dimgrey;
`;

export const Flex = styled.div`
  display: flex;
  gap: 8px;
  height: 24px;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  padding: 2px;
`;

export const FlexPrimary = styled(Flex)`
  background: var(--mode-bg-primary-weakest);
`;
